import styled, { css } from 'styled-components';

import { zoomInSlightlyMixin } from '../animated';

export const Wrapper = styled.div`
  height: 100vh;
  overflow: hidden;
  position: relative;
`;

export const Background = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: calc(100% - 76px);
  margin-top: 76px;
  pointer-events: none;
  background-size: cover;
  background-position: center;

  ${({ theme }) => theme.max('lg')`
    height: calc(100vh - 50px);
    margin-top: 50px;
  `}

  ${({ $bg }) => $bg === 'login' && css`
    background-image: url('https://res.cloudinary.com/dwvhtukvx/image/upload/v1690301295/arootah/fo2rmkcnctze45asorgh.svg');
  `}

  ${({ $bg }) => $bg === 'register' && css`
    background-image: url('https://res.cloudinary.com/dwvhtukvx/image/upload/v1690301193/arootah/th5fipirozhkx2hzgqqq.svg');

    ${({ theme }) => theme.max('md')`
      background-image: url('https://res.cloudinary.com/dwvhtukvx/image/upload/v1690301242/arootah/rwpu4zrnthkklgj06epb.svg');
    `}

    ${({ theme }) => theme.max('sm')`
      background-image: url('https://res.cloudinary.com/dwvhtukvx/image/upload/v1690301270/arootah/ztxpxpjxp7vbojip61fy.svg');
    `}
  `}

  ${({ $bg }) => $bg === 'terms' && css`
    background-image: url('https://res.cloudinary.com/dwvhtukvx/image/upload/v1690301334/arootah/bpgua7xntetj57bovdoz.svg');
  `}

  ${zoomInSlightlyMixin}
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #05192E;
  height: 76px;
  padding: 21px 0 21px 32px;
  position: relative;
  z-index: 1;

  ${({ theme }) => theme.max('lg')`
    height: 50px;
    padding: 10px 0 10px 16px;
    border-bottom: 2px solid #71AACA;

    svg {
      height: 32px;
      width: 100%;
    }
  `}
`;

export const HeaderLeft = styled.div`
  display: flex;
  align-items: center;
`;

export const Content = styled.div`
  height: calc(100vh - 76px);
  overflow-y: auto;

  ${({ theme }) => theme.max('lg')`
    height: calc(100vh - 50px);
  `}
`;
